import { useLocation } from 'react-router-dom';

export function useSwapMode() {
  const { pathname } = useLocation();
  const swapMode = pathname.includes('/refuel') ? 'refuel' : 'swap';

  return swapMode;
}
